<template>
  <div v-if="model.dataService" class="flex items-center space-x-2">
    <img
      :src="getImageForService(model.dataService.id) ?? undefined"
      :alt="`logo for ${
        model.dataService?.name || $t('SCORECARDS.DATA_PROVIDER')
      }`"
      class="h-4 w-4"
      loading="lazy"
    />
    <span>
      {{ model.dataService.name }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { getImageForService } from "@/helpers/services";

import type { ScorecardGroupCategoryForPreview } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<ScorecardGroupCategoryForPreview>,
    required: true,
  },
});
</script>
